import { schema } from "normalizr";
import { topicsTypes } from "../types";
import Resource from "./resource";
import { client } from "../store";

const topicsSchema = new schema.Entity("topics");
export default new Resource("/topics", topicsTypes, topicsSchema);

client.enableAutoCamelCase("/topics");
